export default function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-global-line',
      title: 'Worldwide Support',
      description: 'We serve clients across all continents with dedicated export services and international shipping expertise'
    },
    {
      icon: 'ri-shopping-cart-2-line',
      title: 'MOQ 25 Ton',
      description: 'Flexible minimum order quantity of 25 tons, perfect for bulk buyers and distributors'
    },
    {
      icon: 'ri-box-3-line',
      title: 'Export Packaging',
      description: 'Premium export-grade packaging that meets international standards and ensures product integrity'
    },
    {
      icon: 'ri-time-line',
      title: 'On-Time Delivery',
      description: 'Reliable logistics and timely shipments to build trust and maintain your supply chain efficiency'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <strong className="text-teal-600">Mavani globle</strong>
          </h2>
          <div className="w-24 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Your trusted partner for quality exports and reliable service
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6">
                <i className={`${reason.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {reason.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
